<!--<iframe src="https://playdex.io/games/kryptomon" class="renting-house"></iframe>-->
<iframe [src]="deeplink" class="renting-house"></iframe>